export const WorkspacesUserActionType = {
  WORKSPACE_LIST_ALL: 'actions/workspaceserver/workspaces/LIST_ALL',
  WORKSPACE_LIST: 'actions/workspaceserver/workspaces/LIST',
  WORKSPACE_CREATE: 'actions/workspaceserver/workspaces/CREATE',
  WORKSPACE_GET: 'actions/workspaceserver/workspaces/GET',
  WORKSPACE_EDIT: 'actions/policyserver/roleBindings/UPDATE',
  WORKSPACE_DELETE: 'actions/workspaceserver/workspaces/DELETE',
  WORKSPACE_ARCHIVE: 'actions/workspaceserver/workspaces/ARCHIVE',
  WORKSPACE_ANNOTATION: 'actions/workspaceserver/workspaces/MODIFY_RESOURCE_NAMESPACE_ANNOTATION',
};
